export default "# Forbidden!\n\nWe think you should not be visiting this page. \n\nDid you forget to log in?"